import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ForwardIcon from '@mui/icons-material/Forward';
import MoreVertIcon from '@mui/icons-material/MoreVert';

interface MessageSelectionBarProps {
  count: number;
  onCancel: () => void;
  onForward: () => void;
  onOpenMenu: (anchor: HTMLElement) => void;
}

export const MessageSelectionBar: React.FC<MessageSelectionBarProps> = ({
  count,
  onCancel,
  onForward,
  onOpenMenu,
}) => (
  <Box
    sx={{
      px: 1,
      py: 1,
      bgcolor: '#fff',
      borderBottom: '1px solid #e8eaed',
      display: 'flex',
      alignItems: 'center',
      gap: 1,
    }}
  >
    <IconButton size="small" onClick={onCancel} aria-label="Cancel selection" sx={{ color: '#606060' }}>
      <CloseIcon />
    </IconButton>
    <Typography sx={{ flex: 1, fontWeight: 600, fontSize: '0.95rem', color: '#0f0f0f' }}>
      {count}
    </Typography>
    <IconButton
      size="small"
      onClick={onForward}
      disabled={count === 0}
      aria-label="Forward"
      sx={{ color: '#606060' }}
    >
      <ForwardIcon />
    </IconButton>
    <IconButton
      size="small"
      onClick={(e) => onOpenMenu(e.currentTarget)}
      aria-label="More actions"
      sx={{ color: '#606060' }}
    >
      <MoreVertIcon />
    </IconButton>
  </Box>
);
